// rename this file to options.ts like other packages?

export const OPTION_REFINERS = {
  googleCalendarApiKey: String,
}
